import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const defaultOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      ticks: {
        maxRotation: 45,
        minRotation: 0,
      },
    },
    y: {
      beginAtZero: true,
      ticks: {
        precision: 0,
      },
    },
  },
};

const BarChart = ({ data, height }: { data: any; height?: number }) => {
  const chartOptions = height
    ? { ...defaultOptions, maintainAspectRatio: false }
    : defaultOptions;

  // Remount when labels/values change so Chart.js never keeps a stale frame
  const chartKey = `${(data?.labels || []).join("|")}:${(data?.datasets?.[0]?.data || []).join(",")}`;
  const chart = <Bar key={chartKey} options={chartOptions} data={data} />;

  if (height) {
    return <div style={{ height: `${height}px` }}>{chart}</div>;
  }

  return chart;
};

export default BarChart;
